import { Layout, Row, Col } from "antd";

function Footer() {
  const { Footer: AntFooter } = Layout;

  return (
    <AntFooter style={{ background: "#fafafa" }}>
      <Row className="just">
        <Col xs={12} md={12} lg={12}>
          <div className="copyright">© 2023 tekurious.com</div>
        </Col>
      </Row>
    </AntFooter>
  );
}

export default Footer;
